import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorBankRequest } from 'src/app/models/vendor.model';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { VendorBankService } from 'src/app/services/vendor-bank.service';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-bam-add-favorite',
  templateUrl: './bam-add-favorite.component.html',
  styleUrls: ['./bam-add-favorite.component.scss']
})
export class BamAddFavoriteComponent implements OnInit {
  favoriteType = null; // ACH: 2, BAM: 1
  transferType = 0;
  productType = null;
  productNumber = null;
  bankId = null;
  alias = null;
  email = null;
  vendorBankNumber = null;
  accountBankNumber = null;
  vendorAccounts: VendorBankRequest[] = [];

  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  filterClients = [];
  clientSelected = null;
  selectedOwnAccount: string | null = null;
  selectedThirdPartyAccount: string | null = null;
  currency = 0;
  accountOptions: AccountOptionResponse | null = null;

  accounts: AccountResponse[] = [];
  filterAccounts: AccountResponse[] = [];
  loading = false;

  timeout = null;

  constructor(
    private toastService: ToastrService,
    private vendorService: VendorService,
    private vendorBankService: VendorBankService,
    private accountService: AccountService,
    private bamTransferService: BamTransferServiceService,
    private accService: AccountService,
  ) {

  }

  ngOnInit(): void {
    this.getInitVendors();
    this.getBanksOwn();
    this.getAccountOptions();
  }

  getInitVendors() {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  getBanksOwn() {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data;
        this.filterAccounts = this.accounts;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getAccountOptions() {
    this.accountService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al crear la cuenta");
      }
    })
  }

  getBanksByClient(idVendor: number) {
    this.vendorBankService.getVendorBanksByVendorId(idVendor).subscribe({
      next: (response: ResponseObject) => {
        this.vendorAccounts = response.data;
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    });
  }

  selectClient(client: any) {
    this.clientSelected = client;
    this.getBanksByClient(client.id);
  }


  writeClient() {
    clearTimeout(this.timeout);
    this.client.class = "typing";
    this.timeout = setTimeout(() => {
      this.client.class = "loading";
      this.vendorService.getProvidesByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data;
          if (this.client.filterElements.length == 0) {
            this.client.class = "fa-xmark";
            this.client.required = true;
          } else {
            this.client.class = "fa-filter";
          }
        }, error: (error: any) => {
          this.client.required = true;
          this.client.class = "fa-xmark";
          this.toastService.error("Error al obtener los datos del proveedor " + this.client.value);
        }
      })
    }, 500);
  }

  getBankName(idBank: number): string {
    if (!this.accountOptions || !this.accountOptions.erpBanks) return '';
    const bank = this.accountOptions.erpBanks.find(b => b.id === idBank);
    return bank ? bank.name : 'Banco desconocido';
  }

  getBankAccountTypeName(typeId: number): string {
    if (!this.accountOptions || !this.accountOptions.bankAccountTypes) return '';
    const type = this.accountOptions.bankAccountTypes.find(t => t.id === typeId);
    return type ? type.name : 'Tipo desconocido';
  }

  addFavorite() {
    let data = {};
    console.log(this.favoriteType);
    
    if (this.favoriteType == 'BAM') {
      data = {
        transferType: this.transferType,
        productNumber: this.transferType==0? this.accountBankNumber : this.selectedThirdPartyAccount,
        currency: this.transferType==1? this.currency : null
      }
    } else if (this.favoriteType == 'ACH') {
      data = {
        productNumber: this.productNumber,
        alias: this.alias,
        bankCode: this.bankId,
        productType: this.productType,
        currency: this.currency,
        email: this.email
      }
    }
    
    this.loading = true;
    this.bamTransferService.postLoadFavorite(data).subscribe({
      next: (response: ResponseObject) => {
        this.loading = false;
      },
      error: (error: any) => {
        this.loading = false;
        if (error.data.description) {
          this.toastService.error(error.data.description);
        } else {
          this.toastService.error("Error al agregar favorito");
        }
        
      }
    });
  }

  get isValidFields() {
    if (this.favoriteType == null) return false;

    if (this.favoriteType == 'BAM') {
      if(this.transferType == 0 && this.accountBankNumber!=null) return true;
      else if(this.transferType == 1 && this.selectedThirdPartyAccount!=null && this.currency!=null) return true;
    }
    else if (this.favoriteType == 'ACH') 
      return (this.productType!=null && this.productNumber!=null && this.bankId!=null && this.currency!=null && this.alias!=null && this.email!=null);

    return false;
  }
}